(function() {
    'use strict';
    angular
        .module('emarket.commons')
        .factory('SellerFactory', ['$mdDialog', '$mdMedia', '$rootScope', '$location', '$mdBottomSheet', function($mdDialog, $mdMedia, $rootScope, $location, $mdBottomSheet) {
            var create = function(scope) {
                var factory = {};
                var currentSeller;
                var opening = false;
                var fullScreen = false;
                var ev;
                $location.search('contactar', null);

                var showDialog = function(seller) {
                    return $mdDialog.show({
                        controller: 'SellerContactDialogController as model',
                        templateUrl: 'services/seller/seller-contact-dialog.tpl.html',
                        locals: {
                            seller: seller
                        }
                    });
                };
                var showSheet = function(seller) {
                    if (fullScreen) {
                        $rootScope.$emit('scroll:disable', true);
                    }
                    $mdBottomSheet
                        .show({
                            templateUrl: 'main/post/detail/seller-contact.tpl.html',
                            controller: 'SellerContactSheetController as model',
                            locals: {
                                seller: seller,
                                ev: ev
                            },
                            parent: 'html'
                        })
                        .then(function() {
                            if (fullScreen) {
                                $rootScope.$emit('scroll:disable', false);
                            }
                            $location.search('contactar', null).replace();
                            fullScreen = false;
                        })
                        .catch(function() {
                            if (fullScreen) {
                                $rootScope.$emit('scroll:disable', false);
                            }
                            fullScreen = false;
                            $location.search('contactar', null).replace();
                        });
                };

                factory.showContact = function($ev, seller, _fullScreen) {
                    ev = $ev;
                    currentSeller = seller;
                    opening = true;
                    fullScreen = _fullScreen;

                    if ($mdMedia('xs') || $mdMedia('sm')) {
                        $location.search('contactar', 1);
                    } else {
                        showDialog(seller);
                    }
                };
                var event = $rootScope.$on('$locationChangeSuccess', function() {
                    var params = $location.search();
                    if (params.contactar && opening) {
                        showSheet(currentSeller);
                    } else {
                        $mdBottomSheet.cancel();
                        opening = false;
                    }
                });
                scope.$on('$destroy', function() {
                    event();
                });
                return factory;
            };
            return {
                create: create
            };
        }]);
}());
